
let requireEntry = require.context(
  '@/views/authorized/', // 在当前目录下查找
  false, // 不遍历子文件夹
  /\.vue$/ // 正则匹配 以 .vue结尾的文件
)

let authorizedMenus = []
requireEntry.keys().forEach(fileName => {
  let name = fileName.replace(/^\.\/(.*)\.\w+$/, '$1')
  console.log('name', name)
  authorizedMenus.push({
    path: '/' + name,
    name: name,
    meta: {
      title: name,
      structure: 'FULL', //全页面模式
      code: 'authorized' + name,
      authorized: true,
      structure: 'FULL',
    },
    component: resolve => require([`@/views/authorized/${name}`], resolve)
  })
})

export default authorizedMenus